import React, { useEffect, useMemo, useState } from 'react'
import ErrorBoundary from '../ErrorBoundary'

import ConfigurationContext from '../../contexts/ConfigurationContext'
import { SessionProvider } from '../../contexts/SessionContext'
import { FeatureProvider } from '../../contexts/FeatureContext'
import { SnackBarProvider } from '../../hoc/SnackBarProvider'
import InventoryManagerFloorMap from './InventoryManagerFloorMap'
import UserEventEmitter from '../../libs/UserEventEmitter'
import { UserEventEmitterProvider } from '../../contexts/UserEventEmitterContext'
import { SidebarProvider } from '../../hoc/withSidebar'
import { setWhatsNew } from '../../utils/whatsnew-utils'
import LoadingPlaceholder from '../Misc/LoadingPlaceholder'

interface Props {
  mapBackgroundColor: string
  features: any
  session: any
  onError: any
  configuration: any
}

export default function InventoryManager(props) {
  const { configuration, mapBackgroundColor } = props
  const [loading, setLoading] = useState(true)
  const userEventEmitter = useMemo(() => new UserEventEmitter(), [])
  let unsubscribeUserEvent

  useEffect(() => {
    unsubscribeUserEvent = userEventEmitter.subscribe(onReceiveUserEvent)
    return () => {
      unsubscribeUserEvent()
    }
  }, [userEventEmitter])

  useEffect(() => {
    fetch(
      'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/WhatsNew/whatsnew.json'
    )
      .then(response =>
        response.json().then(data => {
          setWhatsNew(data)
          setLoading(false)
        })
      )
      .catch(e => setWhatsNew([]))
  }, [])

  const styles = {
    root: {
      backgroundColor: mapBackgroundColor,
      fontFamily:
        // eslint-disable-next-line max-len
        '"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Oxygen","Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      display: 'flex',
      position: 'absolute' as 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      overflow: 'hidden',

      '& ::-webkit-scrollbar': {
        width: '6px',
      },

      /* Track */
      '& ::-webkit-scrollbar-track': {
        background: '#f0f0f0',
      },

      /* Handle */
      '& ::-webkit-scrollbar-thumb': {
        background: '#c0c0c0',
      },

      /* Handle on hover */
      '& ::-webkit-scrollbar-thumb:hover': {
        background: '#a0a0a0',
      },
    },
  }

  const onReceiveUserEvent = (event, payload) => {
    emitUserEvent(event, { ...payload })
  }

  const emitUserEvent = (eventName, extra = {}) => {
    // const building = this.state.currentBuilding || {}
    // this.props.onUserEvent(eventName, {
    //   building_uuid: building.uuid,
    //   om_session_id: this.om_session_id_generator(),
    //   location_uuid: building.systemUUID,
    //   location_name: building.name,
    //   ...extra,
    // })
  }
  if (loading) return <LoadingPlaceholder />

  return (
    <UserEventEmitterProvider value={userEventEmitter}>
      <FeatureProvider features={props.features}>
        <SessionProvider value={props.session}>
          <ErrorBoundary onError={props.onError}>
            <ConfigurationContext.Provider value={configuration}>
              <div style={styles.root}>
                <SnackBarProvider>
                  <SidebarProvider>
                    <div
                      style={{
                        flex: 1,
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        zIndex: 0,
                      }}
                    >
                      <InventoryManagerFloorMap
                        {...props}
                        emitUserEvent={e => {
                          // console.log(e)
                        }}
                      />
                    </div>
                  </SidebarProvider>
                </SnackBarProvider>
              </div>
            </ConfigurationContext.Provider>
          </ErrorBoundary>
        </SessionProvider>
      </FeatureProvider>
    </UserEventEmitterProvider>
  )
}
